import React from 'react';
import NoteSticky from '../Icons/NoteSticky'
import House from '../Icons/House'
import Bell from '../Icons/Bell'
import Clipboard from '../Icons/Clipboard';

export default class CalendarIcons extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    return (
      <div className='PropertyCalendarIcons'>
        {self.props.reservation_segment.note_count > 0 && self.props.show_notes ? <><NoteSticky color={this.props.color ? this.props.color : '#000'} /><div className="position-relative"><div className='iconText'>{self.props.reservation_segment.note_count}</div></div></> : null}
        {self.props.reservation_segment.system_notification_count > 0 && self.props.show_notifications ? <><Bell color={this.props.color ? this.props.color : '#000'} /><div className="position-relative"><div className='iconText'>{self.props.reservation_segment.system_notification_count}</div></div></> : null}
        {self.props.reservation_segment.service_log_count > 0 && self.props.show_service_logs ? <><Clipboard /><div className="position-relative"><div className='iconText'>{self.props.reservation_segment.service_log_count}</div></div></> : null}
        {self.props.reservation_segment.housekeeping_count > 0 && self.props.show_housekeeping ? <><House /><div className="position-relative"><div className='iconText'>{self.props.reservation_segment.housekeeping_count}</div></div></> : null}
      </div>
    );
  }
}